
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import LinkButton from 'Src/js/components/LinkButton.vue';

@Component({
	name: 'FulfillmentOptionLinkNew',
	components: {
		LinkButton,
	}
})
class FulfillmentOptionLinkNew extends Vue {
}

export default FulfillmentOptionLinkNew;
